import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { cyclesAPI } from '../../services/api';

export const fetchCycles = createAsyncThunk('cycles/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const { data } = await cyclesAPI.list(params);
    return data;
  } catch (err) { return rejectWithValue(err.response?.data); }
});

export const fetchCycle = createAsyncThunk('cycles/fetchOne', async (id, { rejectWithValue }) => {
  try {
    const { data } = await cyclesAPI.get(id);
    return data;
  } catch (err) { return rejectWithValue(err.response?.data); }
});

export const createCycle = createAsyncThunk('cycles/create', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await cyclesAPI.create(payload);
    return data;
  } catch (err) { return rejectWithValue(err.response?.data); }
});

export const updateCycle = createAsyncThunk('cycles/update', async ({ id, data: payload }, { rejectWithValue }) => {
  try {
    const { data } = await cyclesAPI.update(id, payload);
    return data;
  } catch (err) { return rejectWithValue(err.response?.data); }
});

const cyclesSlice = createSlice({
  name: 'cycles',
  initialState: {
    list: [],
    current: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrent: (s) => { s.current = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCycles.pending, (s) => { s.loading = true; })
      .addCase(fetchCycles.fulfilled, (s, a) => { s.loading = false; s.list = a.payload; })
      .addCase(fetchCycles.rejected, (s) => { s.loading = false; })
      .addCase(fetchCycle.pending, (s) => { s.loading = true; })
      .addCase(fetchCycle.fulfilled, (s, a) => { s.loading = false; s.current = a.payload; })
      .addCase(fetchCycle.rejected, (s) => { s.loading = false; })
      .addCase(createCycle.fulfilled, (s, a) => { s.list.unshift(a.payload); })
      .addCase(updateCycle.fulfilled, (s, a) => { s.current = a.payload; });
  },
});

export const { clearCurrent } = cyclesSlice.actions;
export default cyclesSlice.reducer;
